import { serverTimestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { storage } from "../firebaseConfig";

export const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
    "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const sendEmail = (email, subject, content) => {
  const functions = getFunctions();
  const callableReturnMessage = httpsCallable(functions, "sendEmail");

  callableReturnMessage({
    email: email,
    subject: subject,
    content: content,
  })
    .then((result) => {
      console.log(result, "result in api call");
    })
    .catch((error) => {
      console.log(`error: ${JSON.stringify(error)}`);
    });
};


export const jsonToCSV = (json) => {
  const keys = Object.keys(json[0]).join(",");
  const values = json.map((item) => Object.values(item).join(",")).join("\n");
  return `${keys}\n${values}`;
};


export const userDetails = (usersList) => {
  const arr = usersList.map((user) => ({
    id: user.id,
    Name: user.name,
    "Joined Date": user?.createdAt ? new Date(user.createdAt.toDate()).toDateString() : "",
    "Country Code": user.countryCode,
    Country: user.country,
    "Phone Code": user.phoneCode,
    PhoneNumber: user.phoneNumber,
    Email: user.emailId,
    "Last Login": user?.lastLoginAt ? new Date(user.lastLoginAt.toDate()).toDateString() : "",
  }));
  return arr
}

export const newShelfPackage = (shoppingPackage, itemsData, trackingNumber) => {
  return {
    abandoned: "",
    addonsList: shoppingPackage?.addonsList||[],
    amountDue: 0,
    amountReceived: [],
    arrivedAt: "",
    brand: {
      brandName: itemsData?.brandName || "",
      brandLogo: itemsData?.brandImage || "",
    },
    brandName: itemsData?.brandName || "",
    dimensionH: 0,
    dimensionL: 0,
    dimensionW: 0,
    expectedArrivalDate: "",
    freeStorage: "",
    history: null,
    isExpress: false,
    isNoSuite: false,
    isNoSuite: false,
    isPackageAddedToShipment: false,
    isPackageConsolidated: false,
    isPackageConsolidated: false,
    isUnknown: false,
    merchantIndicator: "",
    mySuiteId: shoppingPackage?.mySuiteId || "",
    mySuiteShipmentId: "",
    packageId: "",
    packageImages: itemsData?.itemImageURL ? [itemsData?.itemImageURL] : [],
    packageItemIds: itemsData?.id ? [itemsData?.id] : [],
    packageName: "",
    packagePhotos: [],
    packageShipmentRequestDate: "",
    packageStatus:"PACKAGE_CREATED",
    // packageShipmentStatus: "NOT PREPARED",
    packageTotalAmount: itemsData?.price || 0 * itemsData?.quantity,
    packageTotalWeight: itemsData?.weight || 0 * itemsData?.quantity,
    packageTrackingId: "",
    paidStorage: "",
    routePartnerId: "",
    serialNumber: "",
    shelfId: "",
    shippedAt: "",
    splitNumber: "",
    splitPackageCost: "",
    suiteNumber: shoppingPackage?.suiteNumber || "",
    trackingNumber: trackingNumber ||"",
    userId: shoppingPackage?.userId ||"",
    warehouseAddressId: shoppingPackage?.warehouseAddressId || "",
    warehouseBayCode: shoppingPackage?.warehouseBayCode || "",
    warehouseRoutePartnerId: shoppingPackage?.warehouseRoutePartnerId || "",
    warehouseRoutePartnerName: shoppingPackage?.warehouseRoutePartnerName || "",
    createdAt: serverTimestamp(),
  }
}

export const uploadDocuments = async (files) => {
  try {

    const uploadPromises = files.map(async (file) => {
      console.log(file.name, "filesfilesfiles");
    
      // Create a reference to the storage location
      const storageRef = ref(storage, `/addons/${file.name}`);
    
      // Start the file upload and get the upload task
      await uploadBytesResumable(storageRef, file);
    
      // After the upload completes, get the download URL
      const logoUrl = await getDownloadURL(storageRef);
      console.log(logoUrl, "logoURLLLLRL");
    
      return logoUrl;
    });
    return await Promise.all(uploadPromises);
  } catch (error) {
    console.log(error, "errpr")
  }
}